(() => {
  const HOTSPOT_INTERPOLATION_MIN = 480;
  const HOTSPOT_INTERPOLATION_MAX = 1400;
  const HOTSPOT_SIDE_BREAKPOINT = 990;
  const sections = document.querySelectorAll('[data-fwmm-section]');

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const parseHotspotValue = (value, fallback) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const animateSection = (section) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.setAttribute('data-fwmm-visible', 'true');
          observer.disconnect();
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    observer.observe(section);
  };

  const initMapping = (section) => {
    const cards = Array.from(section.querySelectorAll('[data-fwmm-card]'));
    const hotspots = Array.from(section.querySelectorAll('[data-fwmm-hotspot]'));
    const anatomy = Array.from(section.querySelectorAll('.fwmm-anat'));
    const ids = [...new Set(cards.map((card) => card.dataset.id).filter(Boolean))];
    if (!ids.length) return;

    let timer = null;
    let index = 0;
    let resizeFrame = null;

    const updateHotspots = () => {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || HOTSPOT_INTERPOLATION_MAX;
      const progress = clamp(
        (viewportWidth - HOTSPOT_INTERPOLATION_MIN) / (HOTSPOT_INTERPOLATION_MAX - HOTSPOT_INTERPOLATION_MIN),
        0,
        1
      );
      const useMobileSide = viewportWidth < HOTSPOT_SIDE_BREAKPOINT;

      hotspots.forEach((hotspot) => {
        const desktopX = parseHotspotValue(hotspot.dataset.hotspotDesktopX, 50);
        const desktopY = parseHotspotValue(hotspot.dataset.hotspotDesktopY, 50);
        const mobileX = parseHotspotValue(hotspot.dataset.hotspotMobileX, desktopX);
        const mobileY = parseHotspotValue(hotspot.dataset.hotspotMobileY, desktopY);
        const nextX = mobileX + ((desktopX - mobileX) * progress);
        const nextY = mobileY + ((desktopY - mobileY) * progress);
        const desktopSide = hotspot.dataset.hotspotDesktopSide === 'right' ? 'right' : 'left';
        const mobileSide = hotspot.dataset.hotspotMobileSide === 'right' ? 'right' : 'left';
        const activeSide = useMobileSide ? mobileSide : desktopSide;

        hotspot.style.left = `${nextX}%`;
        hotspot.style.top = `${nextY}%`;
        hotspot.classList.toggle('fwmm-hotspot--left', activeSide === 'left');
        hotspot.classList.toggle('fwmm-hotspot--right', activeSide === 'right');
      });
    };

    const handleResize = () => {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        updateHotspots();
        resizeFrame = null;
      });
    };

    const activate = (id) => {
      cards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.id === id);
      });

      hotspots.forEach((hotspot) => {
        hotspot.classList.toggle('is-active', hotspot.dataset.id === id);
      });

      anatomy.forEach((item) => {
        const isActive = item.classList.contains(`fwmm-anat--${id}`);
        item.style.opacity = isActive ? '1' : '0';
      });
    };

    const stopAuto = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const bindTarget = (node) => {
      node.addEventListener('click', () => {
        const { id } = node.dataset;
        if (!id) return;
        stopAuto();
        activate(id);
      });
    };

    cards.forEach(bindTarget);
    hotspots.forEach(bindTarget);

    const initial = section.dataset.fwmmInitial && ids.includes(section.dataset.fwmmInitial)
      ? section.dataset.fwmmInitial
      : ids[0];

    updateHotspots();
    window.addEventListener('resize', handleResize, { passive: true });

    activate(initial);
    index = Math.max(ids.indexOf(initial), 0);

    if (ids.length > 1) {
      timer = window.setInterval(() => {
        activate(ids[index]);
        index = (index + 1) % ids.length;
      }, 2800);
    }
  };

  sections.forEach((section) => {
    animateSection(section);
    initMapping(section);
  });
})();
